import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {PaymentMethod} from '../../user/payment-method';
import {Utils} from "../../shared/utils/utils";
import {Product} from "../../websites/website/product";
import {WorkspaceService} from "../workspace.service";
import {first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from "../../store";
import {TypeUtils} from "../../shared/utils/type-utils";

@Injectable()
export class PaymentMethodsResolver implements Resolve<PaymentMethod[]|null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _workspaceService: WorkspaceService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getUserPaymentMethodsLoaded)
        .pipe(
          switchMap(() => this._store.select(fromStore.getUserPaymentMethods)),
          first(data => data && !TypeUtils.isNull(data))
        )
        .subscribe(data => {
          if (data && !TypeUtils.isNull(data)) {
            const paymentMethods = Utils.sort(data, (a: Product, b: Product): number => {
              return a.active === b.active ? 0 : (b.active && !a.active ? 1 : -1);
            });
            resolve(paymentMethods);
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
